import { cn } from '@heroui/react'
import { useMemo } from 'react'

/**
 * Component to display text with effect tags rendered as pills
 * Supports a compact mode for sidebar display
 */
export default function DisplayTaggedText({ text, supportedEffects = [], compact = false, className = '' }) {
  const parsedContent = useMemo(() => {
    if (!text)
      return []

    const segments = []
    let lastIndex = 0
    const regex = /<(\w+)>/g

    let match = regex.exec(text)
    while (match !== null) {
      // Add text before the tag
      if (match.index > lastIndex) {
        segments.push({
          type: 'text',
          content: text.substring(lastIndex, match.index),
        })
      }

      // Add the effect pill
      const effectName = match[1]
      const effect = supportedEffects.find(e => e.name === effectName)
      segments.push({
        type: 'pill',
        content: effectName,
        color: effect?.color || '#e0e7ff',
        textColor: effect?.textColor || '#4838e0',
      })

      lastIndex = match.index + match[0].length
      match = regex.exec(text)
    }

    // Add remaining text after the last tag
    if (lastIndex < text.length) {
      segments.push({
        type: 'text',
        content: text.substring(lastIndex),
      })
    }

    return segments
  }, [text, supportedEffects])

  if (!text)
    return null

  return (
    <span className={cn('inline', className)}>
      {parsedContent.map((segment, index) =>
        segment.type === 'text'
          ? (
              <span key={index}>{segment.content}</span>
            )
          : (
              <span
                key={index}
                className={`inline-flex items-center rounded-full text-xs font-medium mx-0.5 ${
                  compact ? 'px-1 py-0' : 'px-2 py-0.5'
                }`}
                style={{ backgroundColor: segment.color, color: segment.textColor }}
              >
                {segment.content}
              </span>
            ),
      )}
    </span>
  )
}
